/**
 * Checkout page header: back link, title, subtitle.
 * Presentational only; onBack is passed from parent.
 */
const CheckoutHeader = ({ onBack }) => (
  <div className="checkout-header">
    <div className="checkout-header-wrapper">
      <button type="button" onClick={onBack} className="back-link">
        &lt; Back
      </button>
      <h1 className="checkout-title">Checkout</h1>
      <p className="checkout-subtitle">
        Review your order and proceed to payment
      </p>
      <div className="checkout-separator" />
    </div>
  </div>
);

export default CheckoutHeader;
